import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import PessoaJuridicaService from "./pessoaJuridicaService"
import FormList from 'base/FormList'

export default function PessoaJuridicaList() {

    const [service] = useState(() => new PessoaJuridicaService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_pej',
        dsName: 'nome_razao_pes',
        mainField: { name: 'nome_razao_pes', label: 'Nome' },
        advFields: [
            { name: 'nome_razao_pes', label: 'Razão social' },
            { name: 'nome_fantasia_pej', label: 'Fantasia' },
            { name: 'cpf_cnpj_pes', label: 'CNPJ', inputMode: 'numeric' },
            { name: 'descricao_ende', label: 'Rua' },
            { name: 'tel_cel_pes', label: 'Celular', inputMode: 'tel' },
            { name: 'codigo_pej', label: 'Código', type: 'integer', inputMode: 'numeric' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (

        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>

            <Column field="meta.nome_razao_pes" sortable header="Razão social"></Column>
            <Column field="nome_fantasia_pej" sortable header="Fantasia"></Column>

        </FormList >
    )
}
